module.exports = __webpack_public_path__ + "img/locationMap.623342dd.svg";